var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPrevSingle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 13,
    cy: 13,
    r: 13,
    transform: "rotate(-180 13 13)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M13.4768 16.4374C13.7921 16.7491 14.2996 16.7491 14.6149 16.4374C14.848 16.207 14.9191 15.8588 14.795 15.5554L14.0596 13.757C13.9068 13.3834 13.8304 13.1966 13.8304 13C13.8304 12.8034 13.9068 12.6166 14.0596 12.243L14.795 10.4446C14.9191 10.1412 14.848 9.79303 14.6149 9.56262C14.2996 9.25086 13.7921 9.25086 13.4768 9.56261L11.4386 11.5777C10.7611 12.2475 10.4223 12.5824 10.4223 13C10.4223 13.4176 10.7611 13.7525 11.4386 14.4223L13.4768 16.4374Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrevSingle);
export default __webpack_public_path__ + "static/media/icon-prev-single.af8aabcb176b7e9e048bec2c04bc6cb6.svg";
export { ForwardRef as ReactComponent };